import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const merchants = {
  namespaced: true,

  state: () => ({
    loading: false,
    merchantRegistrationSuccess: false,
    merchantRegistrationFailure: false,
    merchantApiSecretKey: null,
    merchantData: {},
    merchants: [],
    merchantApproved: false,
    merchantDisapproved: false,
    merchantActivated: false,
    merchantDeactivated: false,
    merchantDeleted: false,
    activatedMerchants: [],
    deactivatedMerchants: [],
    approvedMerchants: [],
    disapprovedMerchants: [],
    resubmittedMerchants: [],
    merchantsWithIndemnity: [],
    pendingMerchants: []
  }),

  getters: {
    _loading: state => state.loading,
    _merchantRegistrationSuccess: state => state.merchantRegistrationSuccess,
    _merchantRegistrationFailure: state => state.merchantRegistrationFailure,
    _merchantApiSecretKey: (state) => state.merchantApiSecretKey,
    _merchantData: (state) => state.merchantData,
    _merchants: (state) => state.merchants,
    _merchantApproved: (state) => state.merchantApproved,
    _merchantDisapproved: (state) => state.merchantDisapproved,
    _merchantActivated: (state) => state.merchantActivated,
    _merchantDeactivated: (state) => state.merchantDeactivated,
    _merchantDeleted: (state) => state.merchantDeleted,
    // --------------------------------------------
    _activatedMerchants: (state) => state.activatedMerchants,
    _deactivatedMerchants: (state) => state.deactivatedMerchants,
    _approvedMerchants: (state) => state.approvedMerchants,
    _disapprovedMerchants: (state) => state.disapprovedMerchants,
    _resubmittedMerchants: (state) => state.resubmittedMerchants,
    _merchantsWithIndemnity: (state) => state.merchantsWithIndemnity,
    _pendingMerchants: (state) => state.pendingMerchants
  },

  mutations: {
    LOADING (state, value) {
      state.loading = value
    },
    MERCHANT_REGISTRATION_SUCCESS (state, value) {
      state.merchantRegistrationSuccess = value
    },
    MERCHANT_REGISTRATION_FAILURE (state, value) {
      state.merchantRegistrationFailure = value
    },
    MERCHANT_API_SECRET_KEY (state, key) {
      state.merchantApiSecretKey = key
    },
    MERCHANT_DATA (state, data) {
      state.merchantData = data
    },
    MERCHANTS (state, merchants) {
      state.merchants = merchants
    },
    MERCHANT_APPROVED (state, value) {
      state.merchantApproved = value
    },
    MERCHANT_DISAPPROVED (state, value) {
      state.merchantDisapproved = value
    },
    MERCHANT_ACTIVATED (state, value) {
      state.merchantActivated = value
    },
    MERCHANT_DEACTIVATED (state, value) {
      state.merchantDeactivated = value
    },
    MERCHANT_DELETED (state, value) {
      state.merchantDeleted = value
    },
    // ----------------------------------------
    ACTIVATED_MERCHANTS (state, merchants) {
      state.activatedMerchants = merchants
    },
    DEACTIVATED_MERCHANTS (state, merchants) {
      state.deactivatedMerchants = merchants
    },
    APPROVED_MERCHANTS (state, merchants) {
      state.approvedMerchants = merchants
    },
    DISAPPROVED_MERCHANTS (state, merchants) {
      state.disapprovedMerchants = merchants
    },
    RESUBMITTED_MERCHANTS (state, merchants) {
      state.resubmittedMerchants = merchants
    },
    MERCHANTS_WITH_INDEMNITY (state, merchants) {
      state.merchantsWithIndemnity = merchants
    },
    PENDING_MERCHANTS (state, merchants) {
      state.pendingMerchants = merchants
    }
  },
  actions: {
    RegisterMerchant ({ commit, rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/Merchant/CreateMerchant', payload)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(merchant => {
            rootState.loading = false
            // merchant resolved
            resolve(merchant)
          })
          .catch(error => {
            rootState.loading = false
            commit('MERCHANT_REGISTRATION_FAILURE', true)
            reject(error) /* promise rejected */
          })
      })
    },
    // ---------------------------------------
    ApproveMerchant ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/Merchant/ApproveMerchant?MerchantId=${payload.id}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DisapproveMerchant ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/Merchant/DisapproveMerchant?MerchantId=${payload.id}&Comment=${payload.comment}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    ActivateMerchant ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/Merchant/ActivateMerchant?MerchantId=${payload.id}&Comment=${payload.comment}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DeactivateMerchant ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/Merchant/DeactivateMerchant?MerchantId=${payload.id}&Comment=${payload.comment}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    // ---------------------------------------
    GetAPISecretKey ({ rootState, dispatch }, { id, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.get(`/Merchant/GetAPISecretKey?MerchantId=${id}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 1000)
          })
          .catch(error => {
            setTimeout(() => {
              rootState.loading = false
              reject(error)
            }, 1000)
          })
      })
    },

    GetMerchantById ({ rootState, dispatch }, { id, config }) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get(`/Merchant/GetByIdMerchant?MerchantId=${id}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllMerchants ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/Merchant/GetAllMerchants', payload)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    GetAllActivatedMerchants ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/Merchant/GetAllActivatedMerchants', payload)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllDeactivatedMerchants ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/Merchant/GetAllDeactivatedMerchants', payload)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllApprovedMerchants ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/Merchant/GetAllApprovedMerchants', payload)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllDisapprovedMerchants ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/Merchant/GetAllDisapprovedMerchants', payload)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllResubmittedMerchants ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/Merchant/GetAllResubmittedMerchants', payload)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllMerchantsWithIndemnity ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/Merchant/GetAllMerchantsWithIndemity', payload)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllPendingMerchants ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/Merchant/GetAllPendingMerchants', payload)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              resolve(response)
            }
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
    // ------------------------------------------
  }
}

export default merchants
